import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BasetaoSpreadsheet from "../pages/basetao-spreadsheet/page";
import ShoppingGuide from "../pages/shopping-guide/page";
import BasetaoSpreadsheetTemplate from "../pages/basetao-spreadsheet-template/page";
import BasetaoSpreadsheetTutorial from "../pages/basetao-spreadsheet-tutorial/page";
import BasetaoCostTracker from "../pages/basetao-cost-tracker/page";
import BasetaoShippingCalculator from "../pages/basetao-shipping-calculator/page";
import BasetaoQCProcess from "../pages/basetao-qc-process/page";
import BasetaoPromoCode from "../pages/basetao-promo-code/page";
import BasetaoShippingUSA from "../pages/basetao-shipping-usa/page";
import BasetaoVsSuperbuy from "../pages/basetao-vs-superbuy/page";
import BasetaoSpreadsheetDownload from "../pages/basetao-spreadsheet-download/page";
import PlaceholderPage from "../pages/PlaceholderPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shopping-guide/",
    element: <ShoppingGuide />,
  },
  {
    path: "/basetao-spreadsheet/",
    element: <BasetaoSpreadsheet />,
  },
  {
    path: "/basetao-spreadsheet-template/",
    element: <BasetaoSpreadsheetTemplate />,
  },
  {
    path: "/basetao-spreadsheet-tutorial/",
    element: <BasetaoSpreadsheetTutorial />,
  },
  {
    path: "/basetao-spreadsheet-download/",
    element: <BasetaoSpreadsheetDownload />,
  },
  {
    path: "/basetao-cost-tracker/",
    element: <BasetaoCostTracker />,
  },
  {
    path: "/basetao-shipping-calculator/",
    element: <BasetaoShippingCalculator />,
  },
  {
    path: "/basetao-qc-process/",
    element: <BasetaoQCProcess />,
  },
  {
    path: "/basetao-promo-code/",
    element: <BasetaoPromoCode />,
  },
  {
    path: "/basetao-shipping-usa/",
    element: <BasetaoShippingUSA />,
  },
  {
    path: "/basetao-vs-superbuy/",
    element: <BasetaoVsSuperbuy />,
  },
  {
    path: "/basetao-review/",
    element: <PlaceholderPage title="BaseTao Review" />,
  },
  {
    path: "/basetao-shipping-cost/",
    element: <PlaceholderPage title="BaseTao Shipping Cost" />,
  },
  {
    path: "/basetao-coupon/",
    element: <PlaceholderPage title="BaseTao Coupon" />,
  },
  {
    path: "/basetao-warehouse/",
    element: <PlaceholderPage title="BaseTao Warehouse" />,
  },
  {
    path: "/is-basetao-legit/",
    element: <PlaceholderPage title="Is BaseTao Legit?" />,
  },
  {
    path: "/basetao-alternatives/",
    element: <PlaceholderPage title="BaseTao Alternatives" />,
  },
  {
    path: "/about/",
    element: <PlaceholderPage title="About" />,
  },
  {
    path: "/privacy-policy/",
    element: <PlaceholderPage title="Privacy Policy" />,
  },
  {
    path: "/contact/",
    element: <PlaceholderPage title="Contact" />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;